export const manifest = {
  screens: {
    scr_axxh2o: { name: "ALL YOU NEED IS LOVE.", route: "/", state: {"slideIndex":0}, position: {"x":160,"y":1820} },
    scr_ijcf77: { name: "A CONGRESS IS NOT 3 DAYS.", route: "/", state: {"slideIndex":1}, position: {"x":9960,"y":1820} },
    scr_uf0617: { name: "SET THE SCENE", route: "/", state: {"slideIndex":2}, position: {"x":8560,"y":3800} },
    scr_ezxig3: { name: "PLANT THE FIRST QUESTION.", route: "/", state: {"slideIndex":3}, position: {"x":4360,"y":1820} },
    scr_9g32gw: { name: "CREATE THE CONVERSATION", route: "/", state: {"slideIndex":4}, position: {"x":5760,"y":1820} },
    scr_1zcuqq: { name: "FROM AISLE TO CONVERSATION", route: "/", state: {"slideIndex":5}, position: {"x":160,"y":3800} },
    scr_spc9t0: { name: "ASK FIRST. PRESENT SECOND.", route: "/", state: {"slideIndex":6}, position: {"x":12760,"y":1820} },
    scr_r4o317: { name: "IDEAS TRAVEL.", route: "/", state: {"slideIndex":7}, position: {"x":11360,"y":1820} },
    scr_wy4l9u: { name: "TURN IDEAS INTO ACTION", route: "/", state: {"slideIndex":8}, position: {"x":160,"y":5780} },
    scr_taz790: { name: "GIVE THE KNOWLEDGE BACK.", route: "/", state: {"slideIndex":9}, position: {"x":1560,"y":5780} },
    scr_8x451y: { name: "ONE CONTINUOUS CONVERSATION.", route: "/", state: {"slideIndex":10}, position: {"x":14160,"y":1820} },
    scr_uqjkcj: { name: "START SMALL. CONNECT THE THREE ACTS.", route: "/", state: {"slideIndex":11}, position: {"x":15560,"y":1820} },
    scr_ucf396: { name: "WE COULDN’T BRING EVERYONE TO ECCO.", route: "/", state: {"slideIndex":12}, position: {"x":2960,"y":5780} },
    scr_mu75p2: { name: "LET’S START WITH THE FIRST QUESTION.", route: "/", state: {"slideIndex":13}, position: {"x":16960,"y":1820} },
  },
  sections: {
    sec_uu2on6: { name: "Opening Philosophy", x: 0, y: 1600, width: 18320, height: 1180 },
    sec_khh13f: { name: "Booth Experience Flow", x: 0, y: 3580, width: 9920, height: 1180 },
    sec_e8pjri: { name: "Outcomes & Action", x: 0, y: 5560, width: 4320, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_uu2on6", children: [
      { kind: "screen", id: "scr_axxh2o" },
      { kind: "screen", id: "scr_ezxig3" },
      { kind: "screen", id: "scr_9g32gw" },
      { kind: "screen", id: "scr_ijcf77" },
      { kind: "screen", id: "scr_r4o317" },
      { kind: "screen", id: "scr_spc9t0" },
      { kind: "screen", id: "scr_8x451y" },
      { kind: "screen", id: "scr_uqjkcj" },
      { kind: "screen", id: "scr_mu75p2" },
    ] },
    { kind: "section", id: "sec_khh13f", children: [
      { kind: "screen", id: "scr_1zcuqq" },
      { kind: "screen", id: "scr_uf0617" },
    ] },
    { kind: "section", id: "sec_e8pjri", children: [
      { kind: "screen", id: "scr_wy4l9u" },
      { kind: "screen", id: "scr_taz790" },
      { kind: "screen", id: "scr_ucf396" },
    ] },
  ],
}
